import React, { useState } from 'react';
import './Hero.css';

const Hero = () => {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <section
            className="hero"
            style={{
                backgroundColor: '#000000',
            }}
        >
            {/* Loading State */}
            <div className={`hero-loader ${!isLoading ? 'fade-out' : ''}`}>
                <img src="/logo_kotto.png" alt="Loading..." className="loader-logo" />
            </div>

            <video
                autoPlay
                muted
                loop
                playsInline
                className={`hero-video-bg ${!isLoading ? 'fade-in' : ''}`}
                onLoadedData={() => setIsLoading(false)}
            >
                <source src="https://pub-275034f0b1864282a88e9aaf7231e79d.r2.dev/DJ%20Clip%20%2316.mp4" type="video/mp4" />
            </video>
        </section>
    );
};

export default Hero;
